import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "text-lg font-bold text-gray-900 text-left w-full" }, " Salvar configuração como modelo ", -1)
const _hoisted_2 = { class: "flex flex-col gap-4 p-4" }
const _hoisted_3 = { class: "flex gap-4 w-full" }
const _hoisted_4 = { class: "flex-1" }
const _hoisted_5 = { class: "flex-1" }

import { ref, computed, onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import ModalVue from '@/components/designSystem/modals/Modal.vue'
import ApprovalFlowPreview from '@/components/ManageScale/Schedule/ApprovalFlowPreview.vue'
import GenericInput from '@/components/designSystem/Inputs/GenericInput.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import { useCompanyStore } from '@/pinia-store/useCompanyStore'
import type { ApprovalLayerDetail } from '@/Network/Types/Responses/ApprovalFlowResponses'


export default /*#__PURE__*/_defineComponent({
  __name: 'SaveApprovalTemplateModal',
  props: {
    modalActive: { type: Boolean },
    layers: {},
    loading: { type: Boolean }
  },
  emits: ["close", "save"],
  setup(__props: any, { emit }) {

const props = __props;





const companyStore = useCompanyStore()
const { listCompanies } = storeToRefs(companyStore)

const templateName = ref('')
const selectedCompanyId = ref<string | null>(null)

const canSave = computed(() => {
  return templateName.value.trim().length > 0 && selectedCompanyId.value !== null
})

const resetState = () => {
  templateName.value = ''
  selectedCompanyId.value = null
}

const handleClose = () => {
  if (props.loading) return
  resetState()
  emit('close')
}

const handleSave = () => {
  if (!canSave.value || props.loading) return

  emit('save', {
    name: templateName.value.trim(),
    companyId: Number(selectedCompanyId.value)
  })
}

onMounted(() => {
  if (listCompanies.value.length === 0) {
    companyStore.getMyCompanies()
  }
})

return (_ctx: any,_cache: any) => {
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!

  return (_openBlock(), _createBlock(ModalVue, {
    "modal-active": _ctx.modalActive,
    "max-width": "!max-w-[70vw]",
    "has-footer-border": "",
    "has-header-border": "",
    onClose: handleClose
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(OutlineButton, {
            text: "Cancelar",
            width: "100%",
            disabled: _ctx.loading,
            "data-testid": "cancel-save-template-button",
            onClick: handleClose
          }, null, 8, ["disabled"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(FilledButton, {
            text: "Salvar",
            width: "100%",
            disabled: !canSave.value || _ctx.loading,
            loading: _ctx.loading,
            "data-testid": "confirm-save-template-button",
            class: "bg-primary30",
            onClick: handleSave
          }, null, 8, ["disabled", "loading"])
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(ApprovalFlowPreview, { layers: _ctx.layers }, null, 8, ["layers"]),
        _createVNode(GenericInput, {
          modelValue: templateName.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((templateName).value = $event)),
          label: "Nome do modelo",
          "hide-details": "auto",
          "data-testid": "template-name-input"
        }, null, 8, ["modelValue"]),
        _createVNode(_component_v_autocomplete, {
          modelValue: selectedCompanyId.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedCompanyId).value = $event)),
          items: _unref(listCompanies),
          label: "Empresa",
          variant: "outlined",
          density: "comfortable",
          color: "primary20",
          "hide-details": "auto",
          "data-testid": "company-select"
        }, null, 8, ["modelValue", "items"])
      ])
    ]),
    _: 1
  }, 8, ["modal-active"]))
}
}

})